import { Button, Group, Modal } from '@mantine/core';

interface Props {
  opened: boolean;
  onClose: () => void;
  onConfirm: (event: React.FormEvent<HTMLFormElement>) => Promise<void>; // always async call
  onCancel?: (event: React.FormEvent<HTMLFormElement>) => Promise<void>; // optional async call
  title?: string;
  confirmText?: string;
  cancelText?: string;
  closeText?: string;
  children?: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  confirmButtonColor?: 'blue' | 'green' | 'red';
  cancelButtonColor?: 'blue' | 'green' | 'red';
}

export const FormModal = ({
  opened,
  onClose,
  onConfirm,
  onCancel,
  title,
  children,
  confirmText = 'Uložit',
  cancelText = 'Ne',
  closeText = 'Zrušit',
  size = 'lg',
  confirmButtonColor = 'blue',
  cancelButtonColor = 'red',
}: Props) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size={size}
      radius="md"
      withCloseButton={false}
      padding="lg"
    >
      <div className="flex flex-col gap-6">
        {title && <div className="font-bold text-xl">{title}</div>}
        <form className="flex flex-col gap-4">
          {children}
          <Group>
            <Button
              variant="outline"
              radius="md"
              size="md"
              onClick={onClose}
              className="flex-1 text-lg"
            >
              {closeText}
            </Button>
            {onCancel && (
              <Button
                type="button"
                radius="md"
                size="md"
                className="flex-1 text-lg"
                color={cancelButtonColor}
                onClick={e => {
                  e.preventDefault();
                  const formEvent =
                    e as unknown as React.FormEvent<HTMLFormElement>;
                  void onCancel(formEvent);
                }}
              >
                {cancelText}
              </Button>
            )}
            <Button
              type="submit"
              radius="md"
              size="md"
              className="flex-1 text-lg"
              color={confirmButtonColor}
              onClick={e => {
                e.preventDefault();
                const formEvent =
                  e as unknown as React.FormEvent<HTMLFormElement>;
                void onConfirm(formEvent);
              }}
            >
              {confirmText}
            </Button>
          </Group>
        </form>
      </div>
    </Modal>
  );
};

export {};
